import React from 'react';
import { type UseFormReturn } from 'react-hook-form';

import { type ILocationDetailsSchema } from '../helper';
import { CardSection, SummaryHeader, SummarySection } from '../styled';

interface ISummaryProps {
	hookForm: UseFormReturn<ILocationDetailsSchema>;
}
const PrintLocation = ({ hookForm }: ISummaryProps) => {
	const values = hookForm.watch();
	const data = [
		{
			label: 'Polling Unit',
			value: values.entityName,
		},
		{
			label: 'Polling Unit Code',
			value: values.entityCode,
		},
	];
	return (
		<div>
			<SummaryHeader>
				<p className='header'>Location</p>
			</SummaryHeader>
			<SummarySection>
				{data.map((dataItem) => (
					<CardSection key={dataItem.label}>
						<p className='label'>{dataItem.label}</p>
						<h5 className='value'>{dataItem.value}</h5>
					</CardSection>
				))}
			</SummarySection>
		</div>
	);
};

export default PrintLocation;
